/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#unwrapImages(this);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Removes wrapping tags (<p>, <strong>, etc.) around images
   * @param {HTMLElement} root
   */
  #unwrapImages(root) {
    root.querySelectorAll('img').forEach(img => {
      let parent = img.parentNode;

      
      while (parent && parent !== root) {
        const nextParent = parent.parentNode;

        nextParent.insertBefore(img, parent);
        
        if (
          parent.innerHTML.trim() === "" ||
          parent.innerHTML.replace(/<br\s*\/?>/gi, "").trim() === ""
        ) {
          parent.remove();
        }

        parent = nextParent;
      }
    });
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
